// Mock data for $KIM Crypto Landing Page

export const mockData = {
  // Hero Section
  hero: {
    title: "THE SUPREME COIN",
    subtitle: "$KIM",
    tagline: "The Only Cryptocurrency Backed by Supreme Leadership",
    ctaText: "BUY $KIM NOW",
    ctaLink: "https://phantom.app",
    launchDate: "2026-04-24T09:57:00-04:00" // Friday April 24, 2026 at 9:57 AM Eastern Time
  },

  // About Section
  about: {
    title: "SUPREME LEADERSHIP MEETS DECENTRALIZATION",
    description: "In a world of weak cryptocurrencies, $KIM stands as the supreme digital asset. Backed by unparalleled confidence and an unwavering vision, $KIM is not just a token—it's a movement. Join the revolution led by the most powerful figure in crypto.",
    stats: [
      { label: "Total Supply", value: "100,000,000" },
      { label: "Burned", value: "20%" },
      { label: "Holders", value: "Coming Soon" },
      { label: "Liquidity", value: "Locked" }
    ]
  },

  // Tokenomics
  tokenomics: {
    title: "TOKENOMICS FIT FOR A LEADER",
    items: [
      {
        title: "Tax Structure",
        description: "0% Buy / 0% Sell - Because leaders don't need taxes",
        percentage: "0%"
      },
      {
        title: "Liquidity Pool",
        description: "Locked forever. No rug pulls in this regime.",
        percentage: "40%"
      },
      {
        title: "Marketing",
        description: "World domination requires resources",
        percentage: "30%"
      },
      {
        title: "Community",
        description: "For the people, by the Supreme Leader",
        percentage: "30%"
      }
    ]
  },

  // Roadmap
  roadmap: {
    title: "THE PATH TO GLORY",
    phases: [
      {
        phase: "Phase 1",
        title: "THE LAUNCH",
        items: [
          "Website Launch",
          "Social Media Takeover",
          "Initial DEX Offering",
          "CoinGecko & CMC Listing"
        ],
        status: "active"
      },
      {
        phase: "Phase 2",
        title: "EXPANSION",
        items: [
          "10,000+ Holders",
          "Major CEX Listings",
          "Strategic Partnerships",
          "Meme Contest Launch"
        ],
        status: "upcoming"
      },
      {
        phase: "Phase 3",
        title: "DOMINATION",
        items: [
          "50,000+ Holders",
          "NFT Collection Drop",
          "Global Marketing Campaign",
          "Supreme Leader Merch Store"
        ],
        status: "upcoming"
      },
      {
        phase: "Phase 4",
        title: "WORLD SUPREMACY",
        items: [
          "100,000+ Holders",
          "Metaverse Integration",
          "Celebrity Endorsements",
          "To The Moon 🚀"
        ],
        status: "upcoming"
      }
    ]
  },

  // Memes
  memes: {
    title: "MEME GALLERY",
    subtitle: "The People's Humor",
    images: [
      "https://images.unsplash.com/photo-1639815188546-c43c240ff4df",
      "https://images.pexels.com/photos/5980897/pexels-photo-5980897.jpeg",
      "https://images.pexels.com/photos/6770521/pexels-photo-6770521.jpeg",
      "https://images.unsplash.com/photo-1592530392525-9d8469678dac"
    ]
  },

  // Social Links
  social: {
    title: "JOIN THE REGIME",
    links: [
      { name: "Twitter", url: "https://x.com/FlowTraderco", icon: "twitter" },
      { name: "Telegram", url: "#", icon: "send" },
      { name: "Discord", url: "#", icon: "messageCircle" },
      { name: "Instagram", url: "https://www.instagram.com/kim.coin.official?igsh=MTVsbDR4MjMyMGFvYQ%3D%3D&utm_source=qr", icon: "instagram" }
    ]
  },

  // Footer
  footer: {
    disclaimer: "$KIM is a meme cryptocurrency with no intrinsic value or expectation of financial return. This is purely for entertainment purposes. Please invest responsibly.",
    copyright: "© 2025 $KIM. All rights reserved. Supreme Leader approved."
  }
};
